import { createSlice, Slice } from '@reduxjs/toolkit'

import { FilterGroup } from 'context/filtersContext'

export interface FiltersState {
  loaded: boolean
  isFetching: boolean
  defaultFilterId: number | undefined
  savedFilters: FilterGroup[]
}

const initialState: FiltersState = {
  loaded: false,
  isFetching: false,
  defaultFilterId: undefined,
  savedFilters: []
}

export const filtersSlice: Slice<FiltersState> = createSlice({
  name: 'filters',
  initialState,
  reducers: {
    loadSavedFilters: (state, { payload }) => ({
      ...state,
      loaded: true,
      isFetching: false,
      savedFilters: payload
    }),
    saveDefaultFilterId: (state, { payload }) => ({
      ...state,
      defaultFilterId: payload
    })
  }
})

const { reducer: FiltersReducer, actions } = filtersSlice

export const { loadSavedFilters, saveDefaultFilterId } = actions

export default FiltersReducer
